import React from 'react';
import NoMeetingRoomIcon from '@material-ui/icons/NoMeetingRoom';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { BoxStatus } from 'home/useSubBoxStatuses';
import Tooltip from '@material-ui/core/Tooltip';
import { Label } from 'labels';

interface Props {
  status: BoxStatus;
}

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    color: ({ status }: Props) =>
      !status.isOnline
        ? theme.palette.grey[500]
        : status.isOpen
        ? theme.palette.error.main
        : theme.palette.success.main,
  },
}));

const OpenIcon = ({ status }: Props) => {
  const classes = useStyles({ status });

  if (status.isOpen === null) return null;

  return (
    <Tooltip title={status.isOpen ? Label.DoorOpen : Label.DoorClose}>
      {status.isOpen ? (
        <MeetingRoomIcon className={classes.icon} />
      ) : (
        <NoMeetingRoomIcon className={classes.icon} />
      )}
    </Tooltip>
  );
};

export default OpenIcon;
